module.exports = __webpack_public_path__ + "static/media/404.cfd2a123.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/404.png
// module id = 302
// module chunks = 0